export default "__VITE_ASSET__CDiscddF__"